// Shared logic for the medical-concerns / food-allergies fields on Attendee.
//
// Historically these were 'Yes' / 'No' strings (toggle-backed). They're now
// free-text up to FLAG_MAX_LENGTH characters, set on the Add/Edit Attendee
// form and surfaced as chips (with tooltip / italic detail row) elsewhere.
//
// To avoid a one-off migration, callers go through these helpers:
//   - flagOn(value):    is the flag "on"? (any non-empty value except 'No')
//   - flagDetail(value): the detail text to surface, or '' if the value is
//                        a legacy 'Yes' / 'No' placeholder.

export const FLAG_MAX_LENGTH = 200;

export const flagOn = (value: string | undefined | null): boolean => {
  if (!value) return false;
  const trimmed = value.trim();
  if (!trimmed) return false;
  return trimmed.toLowerCase() !== 'no';
};

export const flagDetail = (value: string | undefined | null): string => {
  if (!value) return '';
  const trimmed = value.trim();
  if (!trimmed) return '';
  const lower = trimmed.toLowerCase();
  if (lower === 'yes' || lower === 'no') return '';
  return trimmed;
};
